/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The ManagerAccountControllerDtoNotificationsMarkingAsReadRequest model module.
 * @module model/ManagerAccountControllerDtoNotificationsMarkingAsReadRequest
 * @version 1.0
 */
class ManagerAccountControllerDtoNotificationsMarkingAsReadRequest {
    /**
     * Constructs a new <code>ManagerAccountControllerDtoNotificationsMarkingAsReadRequest</code>.
     * @alias module:model/ManagerAccountControllerDtoNotificationsMarkingAsReadRequest
     */
    constructor() { 
        
        ManagerAccountControllerDtoNotificationsMarkingAsReadRequest.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>ManagerAccountControllerDtoNotificationsMarkingAsReadRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/ManagerAccountControllerDtoNotificationsMarkingAsReadRequest} obj Optional instance to populate.
     * @return {module:model/ManagerAccountControllerDtoNotificationsMarkingAsReadRequest} The populated <code>ManagerAccountControllerDtoNotificationsMarkingAsReadRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new ManagerAccountControllerDtoNotificationsMarkingAsReadRequest();

            if (data.hasOwnProperty('notificationNo')) {
                obj['notificationNo'] = ApiClient.convertToType(data['notificationNo'], ['Number']);
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>ManagerAccountControllerDtoNotificationsMarkingAsReadRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>ManagerAccountControllerDtoNotificationsMarkingAsReadRequest</code>.
     */
    static validateJSON(data) {
        // ensure the json data is an array
        if (!Array.isArray(data['notificationNo'])) {
            throw new Error("Expected the field `notificationNo` to be an array in the JSON data but got " + data['notificationNo']);
        }

        return true;
    }


}



/**
 * @member {Array.<Number>} notificationNo
 */
ManagerAccountControllerDtoNotificationsMarkingAsReadRequest.prototype['notificationNo'] = undefined;






export default ManagerAccountControllerDtoNotificationsMarkingAsReadRequest;

